import { useMe } from '@/features/settings/hooks/useMe'
import { usePermissions } from '@/hooks/usePermissions'
import type { MeRoleId } from '@/types/api.types'
import { useCompanies, useMyCompanies } from './useCompanies'

/**
 * Companies shown in navigation: the organization list for authorized scope-all
 * users, otherwise only the current user's active memberships.
 */
export function useCompanyNavList() {
  const { data: me } = useMe()
  const { can } = usePermissions()
  const scopeAll =
    me?.roleId && typeof me.roleId !== 'string' && (me.roleId as MeRoleId).scope === 'all'
  const canListOrganization = Boolean(scopeAll && can('companies', 'read'))
  const organizationCompanies = useCompanies(undefined, { enabled: canListOrganization })
  const memberCompanies = useMyCompanies({ enabled: Boolean(me) && !canListOrganization })

  return canListOrganization ? organizationCompanies : memberCompanies
}
